import {Dashboard as AdminDashboard} from "Components/Dashboard/Dashboard";
import MainLayout from "Layouts/MainLayout/MainLayout";
export function Dashboard() {
  return (
    <MainLayout>
      <AdminDashboard />
    </MainLayout>
  );
}
